import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { faFileLines, faLocationDot, faReceipt, faXmark } from '@fortawesome/free-solid-svg-icons';
import { TransactionRow } from '../transaction-row';

/** Read-only view of one transaction from the transactions grid. */
@Component({
  selector: 'transaction-detail-dialog',
  templateUrl: './transaction-detail-dialog.component.html',
  styleUrls: ['./transaction-detail-dialog.component.scss']
})
export class TransactionDetailDialogComponent {

  static open(dialog: MatDialog, row: TransactionRow): MatDialogRef<TransactionDetailDialogComponent> {
    return dialog.open(TransactionDetailDialogComponent, { data: row, width: '560px', maxWidth: '95vw' });
  }

  public faFileLines = faFileLines;
  public faLocationDot = faLocationDot;
  public faReceipt = faReceipt;
  public faXmark = faXmark;

  constructor(
    @Inject(MAT_DIALOG_DATA) public row: TransactionRow,
    private dialogRef: MatDialogRef<TransactionDetailDialogComponent>
  ) { }

  close() {
    this.dialogRef.close();
  }
}
